const ERROR_COPY: Record<string, string> = {
  '401': 'Your session has ended. Sign in again.',
  'unauthorized': 'Your session has ended. Sign in again.',
  '403': 'You do not have access to this.',
  'forbidden': 'You do not have access to this.',
  '42501': 'You do not have access to this.',
  'PGRST301': 'You do not have access to this.',
  '404': 'Not found.',
  'PGRST116': 'Not found.',
  '429': 'Too many requests. Try again in a few minutes.',
  'NETWORK': 'No connection. Check your network and try again.',
};

const ERROR_FALLBACK = 'Something went wrong. Try again.';

const HOLDER_ERROR_COPY: Record<string, string> = {
  'holder_not_allowed': 'This person can no longer take this case. Refresh and pick someone else.',
  'holder_no_session_calendar': 'This person has no concierge session calendar. Link one in Admin Manage, or pick someone else.',
  'holder_no_interview_calendar': 'This person has no interview calendar. Link one in Admin Manage, or pick someone else.',
};

export {
  ERROR_COPY,
  ERROR_FALLBACK,
  HOLDER_ERROR_COPY,
};
